import * as React from 'react';
import AppBar from 'material-ui/AppBar';
import appStyles, { StyleProps } from '../../utils/style';
import Toolbar from 'material-ui/Toolbar';
import NavButton from '../../modules/NavButton';
import { withStyles } from 'material-ui/styles';

const styleSheet = appStyles;

class ListToolbar extends React.PureComponent<StyleProps, {}> {
  public render() {
    const { classes } = this.props;

    return (
      <AppBar position="fixed" className={classes.toolbar}>
        <Toolbar>
          <NavButton title="STORIES" cmsNextUrl="/content/stories" />
          <NavButton title="CLUSTERS" cmsNextUrl="/clusters" />
          <NavButton title="BRANDS" cmsNextUrl="/profile/brands" />
          <NavButton title="UPLOADS" destination="/uploads" />
          <NavButton title="IDOLS" destination="/idols" />
          <NavButton
            title="FEATURED CLUSTERS"
            cmsNextUrl="/content/customs?f[term]=homepage"
          />
        </Toolbar>
      </AppBar>
    );
  }
}

export default withStyles(styleSheet)(ListToolbar);



// WEBPACK FOOTER //
// ./src/components/ListToolbar/index.tsx